<script lang="ts" setup>
import { cn } from '@/utils';
import type { BreadcrumbWrapperProps } from '.';

const props = defineProps<BreadcrumbWrapperProps>();
</script>

<template>
	<nav
		aria-label="PilarHomes, navegação"
		:class="cn('text-sm font-normal leading-[150%] text-primary', props.class)"
	>
		<slot />
	</nav>
</template>
